import {CancelBoxRepository, CancelBoxResult} from '@domain/model/Order/CancelBox/CancelBoxRepository';

const CancelBox = (repository: CancelBoxRepository) => (): Promise<CancelBoxResult> => repository.cancelBox();

export {CancelBox};
